// Legacy URL migration map (old WordPress site -> new app).
// Pure data so it can be imported by React (App.js) AND loaded by the
// Node prerender script (scripts/prerender.cjs).
//
// IMPORTANT: Emergent hosting cannot issue true HTTP 301/308 (and cannot issue
// real HTTP 404/410). Confirmed via Emergent support + routing evidence: unknown
// paths are served by SPA static fallback with HTTP 200. So:
//   - Each LEGACY_REDIRECT is implemented two ways: (a) a prerendered standalone
//     static stub at the old path with <meta http-equiv="refresh"> + canonical +
//     noindex + a JS location.replace fallback (served HTTP 200, NOT a 301), and
//     (b) a client-side <Navigate replace> route in App.js for in-SPA navigation.
//   - Each LEGACY_GONE path gets a prerendered noindex "no longer available" stub
//     (served HTTP 200 — a soft 410, because real 410 is not available here).
//
// `flag: true` = destination is a best-effort match the owner should confirm.

export const LEGACY_REDIRECTS = [
  // Allahabad and Prayagraj are a single location.
  { from: "/allahabad-taxi-service", to: "/prayagraj-taxi-service" },
  { from: "/taxi-service-in-allahabad", to: "/prayagraj-taxi-service" },
  // Core pages
  { from: "/contact-us", to: "/contact" },
  { from: "/about-us", to: "/about" },
  { from: "/our-team", to: "/about" },
  { from: "/meet-the-team", to: "/about" },
  { from: "/services-2", to: "/services" },
  { from: "/home", to: "/" },
  { from: "/home/tours", to: "/services" },
  { from: "/travles", to: "/fleet" }, // WP "travels" page -> fleet (owner directive)

  // NOTE: /faq and the Ambakhori/Satpura/Pench "tour" pages were reviewed against
  // their ACTUAL old content and moved to LEGACY_GONE (below). /faq was generic
  // auto-dealership FAQ boilerplate; the "tour" pages were encyclopedia/destination
  // filler with no booking offer and/or destinations outside MP coverage. No genuine
  // replacement exists and we do not invent tour coverage.

  // Vehicle listings — explicit mappings only (NO /listing/* catch-all)
  { from: "/listing/maruti-suzuki-dzire", to: "/fleet" },
  { from: "/listing/toyota-etios", to: "/fleet" },
  { from: "/listing/maruti-suzuki-ertiga", to: "/fleet" },
  { from: "/listing/maruti-suzuki-brezza", to: "/fleet" },
  { from: "/listing/kia-carens", to: "/fleet" },
  { from: "/listing/innova-cresta", to: "/fleet" },
  { from: "/listing/mahindra-scorpio", to: "/fleet" },
  { from: "/listing/mahindra-bolero", to: "/fleet" },
  { from: "/listing/mahindra-bolero-2", to: "/fleet" },
];

// Removed content with NO genuine replacement -> soft-410 noindex stub.
// (Out-of-coverage Maharashtra tours, the old blog, and leftover WordPress
// theme/demo/account pages.)
export const LEGACY_GONE = [
  // Vehicle options removed from the approved fleet.
  "/listing/tempo-traveller-14-seater",
  "/listing/tempo-traveller-19-seater",
  "/listing/tempo-traveller-25-seater",
  "/listing/audi-a4-2018-4-door-sedan-blue",
  "/listing/ford-aspire",

  "/blog",
  // Generic auto-dealership FAQ boilerplate (no relevance to this business)
  "/faq",
  // "Tour" pages that were encyclopedia/destination filler with no actual offering,
  // and/or destinations outside the stated MP service coverage (verified from old content).
  "/ambakhori-waterfall-trek", // page text: "in the heart of Maharashtra", near Pench NP
  "/satpura-hills-pachmarhi", // Wikipedia-style Satpura Range article, no offering
  "/pench-national-park-nature-trek", // Wikipedia-style Pench NP article, no offering
  "/melghat-tiger-reserve",
  "/adasa-ganesh-mandir",
  "/tadoba-andheri-tiger-reserve-kolsa-trek-2",
  // Leftover WordPress theme/demo/account pages
  "/homepage-classic",
  "/homepage-modern",
  "/homepage-mosaic",
  "/homepage-video",
  "/homepage-slideshow",
  "/homepage-location",
  "/compare",
  "/sold",
  "/map-search",
  "/panel",
  "/login-register",
  "/login",
  "/register",
  "/user-profile",
  "/loan-calculator",
  "/404-page",
  "/performers",
  "/venues",
  "/all-events",
  "/booking",
  "/event-types",
  "/submit-event",
  "/booking-details",
  "/event-organizers",
  "/events-list-style",
  "/events-grid-style",
  "/events-list-style-with-search-box",
  "/elementor-23737",
  "/25439-2",
];
